// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__13Snv","pos-center":"Spinner_pos-center__Ie0BD","loader":"Spinner_loader__-uYWW","spin":"Spinner_spin__dYMvB"};